import React from 'react';
import cls from 'js/utils/classNameBuilder.util';
import { Tooltip } from 'js/components/common/Tooltip';

import style from './Label.scss';

// todo id instead of name: need some HOC to add this ID to control,
// also, support custom controls without inputs

export const Label = ({ classNames = {}, id, hint, label, isLabelAsteriskEnabled, className = '', infoTooltip, readOnly, ...props }) => (
    <label
        className={`${cls(['label', readOnly && 'readOnly'], style, classNames)} ${className}`}
        htmlFor={id}
        {...props}
    >
        {label}
        {isLabelAsteriskEnabled && <span className={style.fieldLabelAsterisk}>*</span>}
        {label && infoTooltip && <Tooltip content={infoTooltip} className={style.tooltipIcon} />}
        {hint && <span className={`${cls(['hint'], style, classNames)}`}>{hint}</span>}
    </label>
);
